/* iceberg-ui */
import { Box, Button, Flex, Text } from '@auviknetworks/iceberg-ui';

/* MUI */
import { Checkbox } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/* Components */
import ATRMM from 'application/Home/Partner/Integrations/Pages/ATRMM';
import { Acronis } from 'application/Home/Partner/Integrations/Pages/Acronis';
import { Addigy } from 'application/Home/Partner/Integrations/Pages/Addigy';
import AteraRMM from 'application/Home/Partner/Integrations/Pages/AteraRMM';
import CWAutomate from 'application/Home/Partner/Integrations/Pages/CWAutomate';
import { ConnectWise } from 'application/Home/Partner/Integrations/Pages/ConnectWise';
import { Intune } from 'application/Home/Partner/Integrations/Pages/Intune';
import { Jamf } from 'application/Home/Partner/Integrations/Pages/Jamf';
import KaseyaVSA from 'application/Home/Partner/Integrations/Pages/KaseyaVSA';
import NAble from 'application/Home/Partner/Integrations/Pages/NAble';
import NinjaOne from 'application/Home/Partner/Integrations/Pages/NinjaOne';
import SyncroMSP from 'application/Home/Partner/Integrations/Pages/SyncroMSP';

/* Shared */
import CustomScript from 'application/Shared/Components/CustomScript/Containers/CustomScript';
import { Route } from 'application/Shared/Helpers';

/* Hooks */
import { useSession } from 'hooks/redux/Selectors/session';

/* React */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

const IntegrationComponent = ({ integration }) => {
    const session = useSession();
    switch (integration) {
        case 'acronis':
            return <Acronis onboarding />;
        case 'addigy':
            return <Addigy onboarding />;
        case 'cw_automate':
            return <CWAutomate onboarding session={session} />;
        case 'atera':
            return <AteraRMM onboarding session={session} />;
        case 'at_psa':
            return <ATRMM onboarding session={session} />;
        case 'syncro_msp_rmm':
            return <SyncroMSP onboarding session={session} />;
        case 'n_able':
            return <NAble onboarding session={session} />;
        case 'ninja_one':
            return <NinjaOne onboarding session={session} />;
        case 'kaseya_vsa':
            return <KaseyaVSA onboarding session={session} />;
        case 'intune':
            return <Intune onboarding />;
        case 'jamf':
            return <Jamf onboarding />;
        case 'connectwise':
            return <ConnectWise onboarding />;
        case 'custom_script':
            return <CustomScript onboarding />;
        default:
            return 'Not an option';
    }
};

export const DeployAgentConfigureStep = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { currentSelection: integration, partnerId } = useParams();
    const [isChecked, setChecked] = useState(false);

    const basePartnerRoute = Route.buildBasePartnerRoute({ partnerId });

    return (
        <Flex
            alignItems="center"
            data-testid="onboardingDeployAgentConfigureStep"
            flexDirection="column"
            mt={4}
            mx="4%"
        >
            <Text
                fontSize={['32px', '32px', '32px', 5]}
                color={theme.palette.onboarding.titleTextColor}
                fontWeight="600"
                textAlign="center"
            >
                {t('Onboarding.deployAgentConfigureStep.title')}
            </Text>
            <Text
                fontSize={4}
                color={theme.palette.onboarding.cardBodyText}
                mt={3}
                textAlign="center"
            >
                {t(
                    `Onboarding.deployAgentConfigureStep.subtitle.${integration}`
                )}
            </Text>
            <Flex flexDirection="column" mt="8%" mx="4%" width="100%">
                <IntegrationComponent integration={integration} />
                <hr />
            </Flex>

            <Flex my={4} alignSelf="flex-start" alignItems="baseline">
                <Box width="40px">
                    <Checkbox
                        checked={isChecked}
                        onChange={() => setChecked(!isChecked)}
                        data-testid="agreeCompletedAllDeploymentStepsCheckbox"
                        variant="secondary"
                    />
                </Box>
                <Box flex={1}>
                    <Text color={theme.palette.text.primary}>
                        {t('Onboarding.deployAgentConfigureStep.continue.info')}
                    </Text>
                </Box>
            </Flex>

            <Link
                to={`${basePartnerRoute}/onboarding/deployAgent/completed`}
                style={{
                    alignSelf: 'center',
                    marginBottom: '32px',
                    marginTop: '32px'
                }}
                data-trackid="partner_onboarding_deployAgentConfigureStep_continue_routeTo"
            >
                <Button
                    data-trackid="partner_onboarding_deployAgentConfigureStep_continue"
                    disabled={!isChecked}
                >
                    {t('Onboarding.deployAgentConfigureStep.continue')}
                </Button>
            </Link>

            <Link
                data-trackid="partner_onboarding_deployAgentConfigureStep_goToSelect_routeTo"
                to={`${basePartnerRoute}/onboarding/deployAgent/select`}
                style={{
                    alignSelf: 'center',
                    marginBottom: '32px',
                    marginTop: '32px'
                }}
            >
                <Text
                    color={theme.palette.onboarding.buttonPrimary}
                    fontWeight={600}
                    style={{
                        textTransform: 'uppercase'
                    }}
                >
                    {t('Onboarding.deployAgentConfigureStep.goBack')}
                </Text>
            </Link>
        </Flex>
    );
};
